import { Stack } from '@ui-components/neo.tax';

import { type AscProject } from '@neo.tax/asc/hooks';
import { KeywordSearch } from '@neo.tax/shared';

import { AddContributorButton } from './AddContributorButton';

interface AscProjectTeamMembersToolbarProps {
  ascProject: AscProject;
  searchKeyword: string | null;
  setSearchKeyword: React.Dispatch<React.SetStateAction<string | null>>;
}

export const AscProjectTeamMembersToolbar = ({
  ascProject,
  searchKeyword,
  setSearchKeyword,
}: AscProjectTeamMembersToolbarProps): React.ReactElement => (
  <Stack paddingX={4} paddingY={3} gap={6}>
    <KeywordSearch searchKeyword={searchKeyword} setSearchKeyword={setSearchKeyword} />
    <AddContributorButton ascProject={ascProject} />
  </Stack>
);
